export default __webpack_public_path__ + "static/media/Pulse-1s-200px.4b107bd3.svg";